import { Link } from "react-router-dom";
import { ArrowLeft, Phone } from "lucide-react";

/** Shared retro-themed header + footer wrapper for SEO landing pages. */
export default function SeoLayout({ children, eyebrow }) {
  return (
    <div className="retro min-h-screen relative overflow-hidden">
      <div className="starfield fixed inset-0 opacity-80 pointer-events-none" />

      {/* Top alert */}
      <div className="relative z-40 bg-orange text-white text-center text-xs sm:text-sm label-retro tracking-widest uppercase py-2.5 px-4">
        <span aria-hidden="true" className="mr-2">🚀</span>
        Grand Opening · Save $10 with code <span className="font-bold text-gold">GRAND_OPENING</span>
      </div>

      {/* Header */}
      <header className="relative z-30 border-b border-cream/10 bg-navy/85 backdrop-blur-md sticky top-0">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="seo-home-link">
            <span className="h-10 w-10 rounded-full bg-[#F4EAD5] grid place-items-center overflow-hidden shrink-0">
              <img src="/brand/logo.png" alt="Space Appliance Repair" className="w-[94%] h-[94%] object-contain" style={{ mixBlendMode: "multiply" }} />
            </span>
            <div className="leading-tight">
              <div className="display-retro text-base text-cream uppercase">Space Appliance</div>
              <div className="label-retro text-[10px] text-orange tracking-[0.3em]">Repair Service</div>
            </div>
          </Link>
          <div className="flex items-center gap-2">
            <a href="tel:+12108001710" data-testid="seo-call-btn" className="hidden sm:inline-flex">
              <button className="btn-ghost flex items-center gap-2 label-retro text-xs"><Phone className="w-3.5 h-3.5" /> (210) 800-1710</button>
            </a>
            <Link to="/" data-testid="seo-back-home" className="text-cream/70 hover:text-orange transition-colors flex items-center gap-1 text-sm label-retro">
              <ArrowLeft className="w-4 h-4" /> Home
            </Link>
          </div>
        </div>
      </header>

      <main className="relative z-10">{children}</main>

      {/* Footer */}
      <footer className="relative z-10 border-t border-cream/10 bg-navy py-10 mt-10">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 text-center text-xs label-retro text-cream/50 uppercase">
          © 2026 Space Appliance Repair · 5504 Bandera Rd, San Antonio, TX 78238 · (210) 800-1710
        </div>
      </footer>

      {/* Sticky Mobile Call */}
      <a href="tel:+12108001710" data-testid="sticky-call-space"
        className="md:hidden fixed bottom-5 inset-x-5 z-40 bg-orange text-white rounded-full h-14 flex items-center justify-center gap-2 label-retro uppercase tracking-widest text-sm font-semibold active:scale-95 transition">
        <Phone className="w-5 h-5" /> Call SPACE · (210) 800-1710
      </a>
    </div>
  );
}
